import { useFormikContext } from 'formik'
import ButtonCancel from '../reusable/Buttons/ButtonCancel'
import ButtonSend from '../reusable/Buttons/ButtonSend'

const SupportButtons = () => {
  const { dirty, isValid, isSubmitting, handleReset } = useFormikContext()

  const handleCancel = (e) => {
    // console.log(e)
    handleReset()
  }
  // const handleSend = (e) => {
  //   // will fire this handler but also Formik's onSubmit handler
  //   // console.log(e)
  // }

  return (
    <div className="support_buttons">
      <ButtonCancel handler={handleCancel} disabled={!dirty || isSubmitting} />
      <ButtonSend
        // handler={handleSend}
        disabled={!dirty || !isValid || isSubmitting}
      />
    </div>
  )
}

export default SupportButtons
